export { default as default } from './Contacte';
